// extracted by mini-css-extract-plugin
export default {"brandPromo":"XC-z","carousel":"YC-z"};